import React from 'react';
import { motion } from 'framer-motion';

export default function ColorBlobBackground({ activeColor }) {
  // Spotify Wrapped 2025-ish palette
  // We can shift the hue or opacity based on activeColor if provided
  
  return (
    <div className="absolute inset-0 overflow-hidden bg-[#121212] -z-10">
      {/* Simple Grain Overlay (CSS-based instead of heavy SVG filter) */}
      <div 
        className="absolute inset-0 opacity-[0.03] z-50 pointer-events-none mix-blend-overlay"
        style={{ 
            backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`,
            backgroundSize: '200px 200px'
        }} 
      />

      <motion.div
        className="absolute top-[-20%] left-[-20%] w-[80%] h-[80%] rounded-full mix-blend-screen filter blur-[100px] opacity-80"
        style={{ backgroundColor: '#FF0055' }} // Vivid Pink
        animate={{
          x: [0, 100, -50, 0],
          y: [0, 50, -100, 0],
          scale: [1, 1.5, 0.8, 1],
          rotate: [0, 90, 180, 0]
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute top-[10%] right-[-20%] w-[70%] h-[70%] rounded-full mix-blend-screen filter blur-[120px] opacity-80"
        style={{ backgroundColor: '#00FF99' }} // Neon Green
        animate={{
          x: [0, -100, 50, 0],
          y: [0, 100, -50, 0],
          scale: [1, 1.2, 1.5, 1],
          rotate: [0, -60, 120, 0]
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute bottom-[-20%] left-[20%] w-[90%] h-[90%] rounded-full mix-blend-screen filter blur-[100px] opacity-70"
        style={{ backgroundColor: '#5500FF' }} // Electric Blue/Purple
        animate={{
          x: [0, 50, -50, 0],
          y: [0, -100, 50, 0],
          scale: [1, 1.4, 1],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      
      {/* Vignette */}
      <div className="absolute inset-0 bg-radial-gradient from-transparent to-black/60" />
    </div>
  );
}
